export default __webpack_public_path__ + "f5e4055d65d13fa3efb1859fce5c1c38.svg";